var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_29208",
    "data-name": "Group 29208",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96.001,
    viewBox: "0 0 96 96.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rectangle",
    width: 49,
    height: 49,
    transform: "translate(0.559 0.411)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26955",
    "data-name": "Group 26955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32574",
    "data-name": "Path 32574",
    d: "M40,0A40,40,0,1,1,0,40,40,40,0,0,1,40,0Z",
    transform: "translate(8 8)",
    fill: "#4b74f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32574_-_Outline",
    "data-name": "Path 32574 - Outline",
    d: "M40,0A40,40,0,1,0,80,40,40,40,0,0,0,40,0m0-8A48,48,0,1,1-8,40,48.055,48.055,0,0,1,40-8Z",
    transform: "translate(8 8)",
    fill: "rgba(75,116,244,0.3)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Close",
    transform: "translate(22.877 22.592)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32347",
    "data-name": "Path 32347",
    d: "M23976.863,23223.051l-10.016-10.016-10.008,10.016a1.334,1.334,0,0,1-1.867,0l-2.328-2.336a1.32,1.32,0,0,1,0-1.867l10.008-9.992-10.008-10.008a1.33,1.33,0,0,1,0-1.875l2.328-2.312a1.28,1.28,0,0,1,1.867,0l10,10,10.023-10.023a1.311,1.311,0,0,1,1.859,0l2.336,2.32a1.4,1.4,0,0,1,0,1.891l-10.023,10.008,10.023,10.023a1.316,1.316,0,0,1,0,1.852l-2.336,2.32a1.324,1.324,0,0,1-.93.375A1.3,1.3,0,0,1,23976.863,23223.051Z",
    transform: "translate(-23941.785 -23183.926)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x_icon.18abd99735a1cfd17d928dea7fd06878.svg";
export { ForwardRef as ReactComponent };